module.exports = __webpack_public_path__ + "static/media/icon-stores.bba92951.png";